import { render } from "./CustomSelectbox.vue?vue&type=template&id=ea891a2c"
import script from "./CustomSelectbox.vue?vue&type=script&lang=js"
export * from "./CustomSelectbox.vue?vue&type=script&lang=js"

import "./CustomSelectbox.vue?vue&type=style&index=0&id=ea891a2c&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__